var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icons industries"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2188_381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    width: 40,
    height: 40,
    fill: "#5D8DE9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2188_381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "account_balance",
    d: "M25.96,8.73C25.84,8.29,25.42,7.95,24.97,8c-0.46,0.02-0.85,0.34-0.95,0.8c-0.42,2.01-1.8,4.26-3.01,4.26 c-0.4,0-0.82-0.25-1.27-0.74C18.15,10.59,17.22,4.21,17,1.9c-0.04-0.36-0.28-0.68-0.62-0.82c-0.34-0.14-0.73-0.09-1.01,0.15 c-4.99,4.1-5.49,10.56-5.45,13.44c-2.04-1.03-2.95-3.93-2.96-3.96C6.82,10.26,6.41,9.96,5.93,10c-0.47,0.04-0.85,0.38-0.92,0.85 c-1.19,7.61-0.29,13.22,2.65,16.66c2.72,3.17,6.36,3.5099,7.79,3.5099c0.38,0,0.62-0.02,0.62-0.02c3.75-0.25,6.6-1.7,8.47-4.33 C29.09,20.27,26.09,9.2,25.96,8.73z",
    fill: "#5D8DE9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/Energy.fff2a5251e7efacea913eeb99014f7fe.svg";
export { ForwardRef as ReactComponent };